import { createGlobalStyle } from "styled-components";
import colors from "./colors";
import prism from "./prism";
import font from "./fonts";

const GlobalStyles = createGlobalStyle`
  ${prism};

  html,
  body,
  #root,
  #gatsby-focus-wrapper,
  #___gatsby {
    margin: 0;
    padding: 0;
    height: 100vh;
    width: 100vw;
    text-size-adjust: 100%;

    color: ${colors.white};
    font-size: 100%;
  }

  body {
    font-size: ${font.globalFontSize};
    line-height: ${font.globalLineHeight};
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    line-height: 1.4;
    box-sizing: border-box;
  }

  div {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }

`;

export default GlobalStyles;
